import React from "react";

import { getTranslation } from "../../../helpers/getLanguage";
import ConfirmationModal from "../../dialogs/ConfirmationModal";

const ConfirmationDeleteModal = ({ handleCloseDeleteModal, handleDelete, getActiveTypeAndSize }) => {
  const checkEmpty = getActiveTypeAndSize().split("_")[1] === "EMPTY";

  return (
    <ConfirmationModal
      className="delete-conformation-modal"
      textContainerClass="span-delete-modal"
      closeDialog={handleCloseDeleteModal}
      message={getTranslation(`CONFIRMATION_DELETE_MODAL_${getActiveTypeAndSize()}`)}
      autoFocus={true}
      buttonText={
        checkEmpty
          ? getTranslation("CONFIRMATION_MODAL_DEFAULT_BUTTON_TEXT")
          : getTranslation("CONFIRM_MODAL_DELETE_BUTTON_TEXT")
      }
      onConfirm={checkEmpty ? handleCloseDeleteModal : handleDelete}
      cancelButton={!checkEmpty && getTranslation("CANCEL")}
    />
  );
};

export default ConfirmationDeleteModal;
